import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { Link } from '@stackflow/link';
import { useTranslation } from 'react-i18next';

import PlusIcon from './PlusIcon';

function Blank() {
    const { t } = useTranslation('prepaidCard');
    return (
        <Container fullWidth
            as='section'
            align='center'
            spacing={6}>
            <BuyLink activityParams={{ type: 'BUY' }}
                activityName='PrepaidCardImagesActivity'>
                <BuyCard justify='center' align='center' spacing={2}>
                    <PlusIcon />
                    <Text size='body-short' color={colors.textSecondary} fontWeight='medium' multiline align='center'>
                        {t('blank.description')}
                    </Text>
                </BuyCard>
            </BuyLink>
        </Container>
    );
}

const Container = styled(Column)`
    background-color: var(--color-white);
    padding: 16px 16px 48px;
`;

const BuyLink = styled(Link)`
    display: block;
    text-decoration: none;
    width: 100%;
`;

const BuyCard = styled(Column)`
    aspect-ratio: 3 / 2;
    background-color: var(--color-white);
    border: 2px dashed var(--color-gray4);
    border-radius: 12px;
    cursor: pointer;
    width: 100%;
`;

export default Blank;
